declare var pm: PmInterface;

export default function setupFollowArtist() {
	let doingAjax = false;

	init();

	/**
	 * Initialize the module, call the main functions.
	 *
	 * This function is the only function that should be called on top level scope.
	 * Other functions are called / hooked from this function.
	 */
	function init() {
		jQuery(document).on("click", ".follow-action", followOrUnfollowUser);
	}

	/**
	 * Follow or unfollow user.
	 */
	function followOrUnfollowUser(this: HTMLElement, e: JQuery.Event) {
		if (!document.body.classList.contains("logged-in")) return;
		e.preventDefault();

		if (doingAjax) return;
		this.classList.add("is-processing");
		doingAjax = true;

		const button = this;
		const actionType = button.dataset.actionType;

		if ("follow" === actionType) {
			followUser(button);
		} else {
			unfollowUser(button);
		}

		jQuery
			.ajax({
				url: pm.ajaxurl,
				type: "POST",
				data: {
					action: "pm_save_follow_action",
					nonce: pm.nonces.followOrUnfollowUser,
					user_id: button.dataset.userId,
					action_type: actionType,
				},
			})
			.done(function (r) {
				if (r.success) {
					return;
				}

				if ("follow" === actionType) {
					unfollowUser(button);
				} else {
					followUser(button);
				}

				pm.utils.alert.show("error", r.data);
			})
			.fail(function () {
				if ("follow" === actionType) {
					unfollowUser(button);
				} else {
					followUser(button);
				}

				pm.utils.alert.show("error", "Something went wrong. Please try again.");
			})
			.always(function () {
				doingAjax = false;
				button.classList.remove("is-processing");
			});
	}

	function followUser(button: HTMLElement) {
		const textSpan = button.querySelector(".button-text");

		if (textSpan) {
			textSpan.textContent = "Following";
		}

		const titleEl = button.querySelector("title");

		if (titleEl) {
			titleEl.textContent = "Unfollow this artist";
		}

		button.dataset.actionType = "unfollow";
		button.classList.add("is-active");
	}

	function unfollowUser(button: HTMLElement) {
		const textSpan = button.querySelector(".button-text");

		if (textSpan) {
			textSpan.textContent = "Follow";
		}

		const titleEl = button.querySelector("title");

		if (titleEl) {
			titleEl.textContent = "Follow this artist";
		}

		button.dataset.actionType = "follow";
		button.classList.remove("is-active");
	}

	return {};
}
